import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customImageFormatMultiselectValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value: Array<boolean | string> = control.value;
    const notEmptyValues = value.filter((v) => !!v);
    return notEmptyValues.length ? null : { required: true };
  };
}
